import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {SearchTypeCustom, TSearchTypeCustom} from './constants';
import {customRuleDefaults} from './defaults';
import type {CustomRule} from './types';
import {validateCustomRule} from './validate';

export class CustomRuleModel
	extends RuleModel<TSearchTypeCustom>
	implements CustomRule
{
	readonly elementType = SearchTypeCustom;
	elementSubType1 = customRuleDefaults.elementSubType1;
	elementSubType2: 0 = customRuleDefaults.elementSubType2;
	elementValue1 = customRuleDefaults.elementValue1;
	elementValue2: '' = customRuleDefaults.elementValue2;
	elementValue3: '' = customRuleDefaults.elementValue3;

	get isValid() {
		const validation = validateCustomRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<CustomRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...customRuleDefaults, ...params});
		});

		makeObservable(this, {
			isValid: computed,
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementValue1: observable,
			setElementSubType1: action,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set custom
	 * @param elementValue1 custom
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default CustomRuleModel;
